/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RaceConfig } from './RaceConfig';
import {
    RaceConfigFromJSON,
    RaceConfigFromJSONTyped,
    RaceConfigToJSON,
    RaceConfigToJSONTyped,
} from './RaceConfig';
import type { ShowdownConfig } from './ShowdownConfig';
import {
    ShowdownConfigFromJSON,
    ShowdownConfigFromJSONTyped,
    ShowdownConfigToJSON,
    ShowdownConfigToJSONTyped,
} from './ShowdownConfig';
import type { TimeAttackConfig } from './TimeAttackConfig';
import {
    TimeAttackConfigFromJSON,
    TimeAttackConfigFromJSONTyped,
    TimeAttackConfigToJSON,
    TimeAttackConfigToJSONTyped,
} from './TimeAttackConfig';
import type { BestOfConfig } from './BestOfConfig';
import {
    BestOfConfigFromJSON,
    BestOfConfigFromJSONTyped,
    BestOfConfigToJSON,
    BestOfConfigToJSONTyped,
} from './BestOfConfig';

/**
 * Per-strategy configuration mapping
 * @export
 * @interface StrategyConfigs
 */
export interface StrategyConfigs {
    /**
     * 
     * @type {BestOfConfig}
     * @memberof StrategyConfigs
     */
    FIRST_TO_WINS?: BestOfConfig;
    /**
     * 
     * @type {RaceConfig}
     * @memberof StrategyConfigs
     */
    METRIC_THRESHOLD?: RaceConfig;
    /**
     * 
     * @type {TimeAttackConfig}
     * @memberof StrategyConfigs
     */
    SCORE_ACCUMULATION?: TimeAttackConfig;
    /**
     * 
     * @type {ShowdownConfig}
     * @memberof StrategyConfigs
     */
    MATCH_RESULT?: ShowdownConfig;
}

/**
 * Check if a given object implements the StrategyConfigs interface.
 */
export function instanceOfStrategyConfigs(value: object): value is StrategyConfigs {
    return true;
}

export function StrategyConfigsFromJSON(json: any): StrategyConfigs {
    return StrategyConfigsFromJSONTyped(json, false);
}

export function StrategyConfigsFromJSONTyped(json: any, ignoreDiscriminator: boolean): StrategyConfigs {
    if (json == null) {
        return json;
    }
    return {
        
        'FIRST_TO_WINS': json['FIRST_TO_WINS'] == null ? undefined : BestOfConfigFromJSON(json['FIRST_TO_WINS']),
        'METRIC_THRESHOLD': json['METRIC_THRESHOLD'] == null ? undefined : RaceConfigFromJSON(json['METRIC_THRESHOLD']),
        'SCORE_ACCUMULATION': json['SCORE_ACCUMULATION'] == null ? undefined : TimeAttackConfigFromJSON(json['SCORE_ACCUMULATION']),
        'MATCH_RESULT': json['MATCH_RESULT'] == null ? undefined : ShowdownConfigFromJSON(json['MATCH_RESULT']),
    };
}

export function StrategyConfigsToJSON(json: any): StrategyConfigs {
    return StrategyConfigsToJSONTyped(json, false);
}

export function StrategyConfigsToJSONTyped(value?: StrategyConfigs | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'FIRST_TO_WINS': BestOfConfigToJSON(value['FIRST_TO_WINS']),
        'METRIC_THRESHOLD': RaceConfigToJSON(value['METRIC_THRESHOLD']),
        'SCORE_ACCUMULATION': TimeAttackConfigToJSON(value['SCORE_ACCUMULATION']),
        'MATCH_RESULT': ShowdownConfigToJSON(value['MATCH_RESULT']),
    };
}

